import * as Mousetrap from 'mousetrap';
import { Module } from '../../ts/Module';
import { TopBarService } from '../../ts/services/TopBarService';

/**
 * Adds key handlers for global keyboard shortcuts.
 */
export class GlobalShortcutService {

  private topBarService: TopBarService;
  public static $inject = [
    'TopBarService'
  ];

  public constructor(
    topBarService: TopBarService
  ) {
    this.topBarService = topBarService;
  }

  public setupGlobalShortcuts() {
    Mousetrap.bind('/',
      (_e: ExtendedKeyboardEvent) => {
        this.topBarService.openSearch();
      });
  }
}


Module.instance().service('GlobalShortcutService', GlobalShortcutService);
